
var LocalStorage = {
  get: function (key) {
    var value = localStorage.getItem(key)
    if (value) {
      try {
        var valueJson = JSON.parse(value)
        if (typeof valueJson === 'object') {
          return valueJson
        } else if (typeof valueJson === 'number') {
          return valueJson
        }
      } catch (e) {
        return value
      }
    } else {
      return false
    }
  },
  set: function (key, value) {
    localStorage.setItem(key, value)
  },
  remove: function (key) {
    localStorage.removeItem(key)
  },
  clear: function () {
    localStorage.clear()
  }
}
// 在此基础之上，可以扩展很多方法，比如批量保存或删除一些数据：
// 批量保存，data是一个字典
LocalStorage.setList = function (data) {
  for (var i in data) {
    localStorage.setItem(i, data[i])
  }
}

// 批量删除，list是一个数组
LocalStorage.removeList = function (list) {
  for (var i = 0, len = list.length; i < len; i++) {
    localStorage.removeItem(list[i])
  }
}

export default LocalStorage



// WEBPACK FOOTER //
// ./src/public/localStorage.js